import { useState } from "react";
import { teamKit, readableOn, initialsOf } from "../../utils/footballTeams";

/**
 * PlayerAvatar — real photo when available, else a jersey-colored circle with
 * the player's initials (consistent with PitchView). Used in list rows.
 */
export const PlayerAvatar = ({ player = {}, size = 44 }) => {
  const [err, setErr] = useState(false);
  const [primary, secondary] = teamKit(player.team_name || player.team?.name, player.team_id || player.team?.id);
  const fg = readableOn(primary);

  if (player.photo_url && !err) {
    return (
      <img
        src={player.photo_url}
        alt={player.name}
        onError={() => setErr(true)}
        style={{ width: size, height: size }}
        className="rounded-full object-cover bg-slate-800"
        data-testid={`avatar-${player.player_id || player.id || "x"}`}
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size, background: primary, color: fg, border: `2px solid ${secondary}` }}
      className="grid place-items-center rounded-full text-[13px] font-extrabold"
      data-testid={`avatar-${player.player_id || player.id || "x"}`}
    >
      {initialsOf(player.name)}
    </div>
  );
};

export default PlayerAvatar;
